import React, { useState, createContext, useEffect, useContext} from "react"

export const PopupNotifContext = createContext()

const PopupNotifProvider = ({ children }) => {

  const [notifs, setNotifs] = useState([])
  const [haveToDisplay, setHaveToDisplay] = useState(null)

  const addPopupNotif = (vals) => {
    let act = JSON.parse(JSON.stringify(notifs))
    vals.createdAt = Date.now();
    act.push(vals)

    setNotifs(act)
  }

  const removeByUUID = (uuid) => {
    let act = JSON.parse(JSON.stringify(notifs))
    act = act.filter((el) => el.uuid !== uuid)
    setNotifs(act)
  }

  useEffect(() => {
    if (notifs?.length > 0) {
      let last = notifs[notifs.length-1]
      setHaveToDisplay(last)
    } else {
      setHaveToDisplay(null)
    }
  }, [notifs])

  useEffect(() => {
    // create a interval and get the id
    const myInterval = setInterval(() => {
      if (notifs?.length > 0) {
        let actTime = Date.now()
        notifs.forEach((notif) => {
          let diff = actTime - (notif?.createdAt+notif?.removeAfter)
          if (diff > 0) {
            removeByUUID(notif?.uuid)
          }
        })
      }
    }, 1000);
    // clear out the interval using the id when unmounting the component
    return () => clearInterval(myInterval);
  }, [notifs]);

  return (
    <PopupNotifContext.Provider
      value={{
        notifs,
        addPopupNotif,
        removeByUUID,
        haveToDisplay,
      }}
    >
      {children}
    </PopupNotifContext.Provider>
  )
}

export default PopupNotifContext

export { PopupNotifProvider }
